module.exports = __webpack_public_path__ + "img/tiles-03.12b616b8.svg";